export const JOURNEY_NAVIGATION_EVENT = 'JourneyNavigationEvent'
export const JOURNEY_LOADING_EVENT = 'JourneyLoadingEvent'
export const JOURNEY_EXIT_EVENT = 'JourneyExitEvent'
